import { useState, useEffect, useCallback, useMemo } from 'react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { layoutService } from '@/services/layout-service';



// Define a type for the cache
type CacheStore<T> = {
  [key: string]: T;
}

const useBadgeData = <T>() => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const cache = useCallback(() => {
    const cacheStore: CacheStore<T> = {};
    return {
      get: (key: string): T | undefined => cacheStore[key],
      set: (key: string, value: T): void => { cacheStore[key] = value; }
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      const cachedData = cache().get('badge');
      if (cachedData) {
        setData(cachedData);
        setLoading(false);
        return;
      }

      try {
        const response = await layoutService.getProductBadges()
        setData(response.data.data);
        cache().set('badge', response.data.data);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return useMemo(() => ({ data, loading, error }), [data, loading, error]);
};

export default useBadgeData;
